// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3nbK9","search":"Settings_search__3M-bb","filter":"Settings_filter__lVtfs"};